import { NgOptimizedImage } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { StatModule } from '@cargos/sprintpay-services';
import { isConfigPresent } from '@cargos/sprintpay-tools';
import { CoreModule } from 'src/app/shared/modules/core/core.module';
import { SanitizerPipe } from 'src/app/shared/pipes/sanitizer.pipe';
import { AccessoriesDefaultImplementationService } from 'src/app/shared/services/accessories/accessories-default-implementation.service';
import { AccessoriesService } from 'src/app/shared/services/accessories/accessories.service';
import { environment } from 'src/environments/environment';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderDHLComponent } from './components/header/header.component';
import { DHLFacilityConfig } from './config/facility-config';
import { DHLRoutingModule } from './dhl-routing.module';
import { DHLComponent } from './dhl.component';
import { FacilityInformationComponent } from './pages';
import { ChunkErrorHandler } from './services/chunk-error-handler.service';

@NgModule({
    imports: [
        DHLRoutingModule,
        CoreModule.forRoot(),
        NgOptimizedImage,
        MatDividerModule,
        SanitizerPipe,
        StatModule.forRoot({
            enableStatsig: isConfigPresent(environment.statsigSdkKey),
            sdkKey: environment.statsigSdkKey ?? '',
            user: {},
            options: {
                environment: {
                    tier: environment.environment === 'develop' ? 'development' : environment.environment,
                },
            },
        }),
    ],
    declarations: [DHLComponent, FacilityInformationComponent, HeaderDHLComponent, FooterComponent],
    bootstrap: [DHLComponent],
    providers: [
        {
            provide: AccessoriesService,
            useClass: AccessoriesDefaultImplementationService,
        },
        { provide: ErrorHandler, useClass: ChunkErrorHandler },
        DHLFacilityConfig,
    ],
})
export class DHLModule {}
